import * as Broker from "message-broker";

export const onMessage = (event: MessageEvent<any>) => {
  if (["LOG", "LOG_WARNING", "LOG_ERROR"].includes(event.data?.type)) {
    const message = "[Service Worker] " + event.data.message;

    if (Broker.isNativeApp()) {
      Broker.sendToNative({
        type: "log",
        payload: {
          level:
            event.data?.type === "LOG"
              ? "log"
              : event.data?.type === "LOG_WARNING"
                ? "warning"
                : "error",
          message: message,
        },
      });
    } else {
      if (event.data.type === "LOG") {
        console.log(message);
      } else if (event.data.type === "LOG_WARNING") {
        console.warn(message);
      } else if (event.data.type === "LOG_ERROR") {
        console.error(message);
      }
    }
  }
};
